module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/meal-80d142b7d0eec586688787bbb5017dc5.webp";